import { MockAPI } from "@lib/services/http";

import MockAdapter from "axios-mock-adapter";

export default new MockAdapter(MockAPI, { delayResponse: 100 });
